/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Faint_Free_Ant_PlayInputs */

const en_faint_free_ant_play = /** @type {(inputs: Faint_Free_Ant_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shared at ${i?.date} o'clock`)
};

const de_faint_free_ant_play = /** @type {(inputs: Faint_Free_Ant_PlayInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geteilt am ${i?.date} Uhr`)
};

/**
* | output |
* | --- |
* | "Shared at {date} o'clock" |
*
* @param {Faint_Free_Ant_PlayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const faint_free_ant_play = /** @type {((inputs: Faint_Free_Ant_PlayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faint_Free_Ant_PlayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faint_free_ant_play(inputs)
	return de_faint_free_ant_play(inputs)
});